import React, {useEffect, useState} from "react";
import Button from "../../components/v2/Button";
import StepperCar from "../../components/v2/StepperCar";
import Input from "../../components/v2/Input";
import useValetStore from "./hooks/useValetStore";
import {PaymentType} from "../../constants/PaymentType";
import Swal from "sweetalert2";
import {ValetSteps} from "./constants/ValetSteps";
import {useSelector} from "react-redux";
import {getBrandData} from "../branded/locationGroupSlice";
import {useTranslation} from "react-i18next";

export default function ValetPaymentInvoice({}) {

    const {
        callPost,
        userData,
        valetIntent,
        setStep
    } = useValetStore();

    const [invoiceCostCenter, setInvoiceCostCenter] = useState('');
    const [invoiceName, setInvoiceName] = useState('');
    const [invoiceAddress, setInvoiceAddress] = useState('');
    const [invoicePostalCode, setInvoicePostalCode] = useState('');
    const [invoiceCity, setInvoiceCity] = useState('');

    const formRef = React.useRef();

    const brandData = useSelector(getBrandData);

    const {t} = useTranslation('common');

    const payClickedHandler = function (e) {
        if (!formRef.current.reportValidity()) {
            return;
        }
        // TODO Pas mal redondant avec ValetPaymentStripe
        callPost('valet_only_order_intent', {
            'valet_intent_id': valetIntent.id,
            'vehicle_id': userData.vehicle.vehicle.id,
            'date': userData.travel.date,
            'time': userData.travel.time,
            'retrieve_hour': userData.travel.retrieveHour,
            'phone': userData.travel.phone,
            'comment': userData.travel.comment,
            'delivery_contact_name': userData.travel.deliveryContactName,
            'delivery_contact_phone': userData.travel.deliveryContactPhone,
            'payment_type_id': PaymentType.INVOICE,
            'invoice_name': invoiceName,
            'invoice_cost_center': invoiceCostCenter,
            'invoice_address': invoiceAddress,
            'invoice_postal_code': invoicePostalCode,
            'invoice_city': invoiceCity,
            'location_group_id': brandData?.id
        }, (data) => {
            setStep(ValetSteps.ORDER_DONE);
        }, (failResultData) => {
            Swal.fire({
                text: failResultData.message,
                icon: 'error',
            });
        });
    }

    return <div className="h-full flex flex-col p-4 gap-4">
        <StepperCar value={90}/>
        <div className="text-white text-[30px] font-bold">
            {t('valet.payment_invoice.title')}
        </div>
        <form ref={formRef}>
            <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
                <legend className="text-sm">&nbsp;{t('valet.payment_invoice.detail')}&nbsp;</legend>
                <Input id="brand" label={t('valet.payment_invoice.cost_center')} placeholder=""
                       value={invoiceCostCenter}
                       required={true}
                       maxlength={20}
                       onChange={(e) => setInvoiceCostCenter(e)}
                />
                <Input id="brand" label={t('valet.payment_invoice.name')} placeholder=""
                       value={invoiceName}
                       required={true}
                       onChange={(e) => setInvoiceName(e)}
                />
                <Input id="brand" label={t('valet.payment_invoice.address')} placeholder=""
                       value={invoiceAddress}
                       required={true}
                       onChange={(e) => setInvoiceAddress(e)}
                />
                <Input id="brand" label={t('valet.payment_invoice.postal_code')} placeholder=""
                       value={invoicePostalCode}
                       required={true}
                       onChange={(e) => setInvoicePostalCode(e)}
                />
                <Input id="brand" label={t('valet.payment_invoice.city')} placeholder=""
                       value={invoiceCity}
                       required={true}
                       onChange={(e) => setInvoiceCity(e)}
                />
            </fieldset>
        </form>
        <div className="grow">
        </div>

        <Button text={t('valet.payment_invoice.validate')} clickHandler={payClickedHandler}/>
        <Button outline text={t('valet.payment_invoice.back')} clickHandler={(e) => setStep(ValetSteps.SUMMARY)}/>
    </div>
}